export const SET_THEME = 'THEME/SET_THEME';
export const SET_COLOR_SCHEME = 'THEME/SET_COLOR_SCHEME';
export const SET_COMPONENT_THEME = 'THEME/SET_COMPONENT_THEME';
export const SET_THEME_UPDATE_LOADING = 'THEME/SET_THEME_UPDATE_LOADING';
